import { Container, Row, Col } from "reactstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./CourseReasons.css";

function CourseReasons({
    courseName = "Course",
    reasons = [],
}) {
    if (!reasons || reasons.length === 0) {
        return null;
    }

    return (
        <section className="course-reasons-section">
            <Container>

                {/* Header */}
                <div className="course-reasons-header">

                    <span className="course-reasons-badge">
                        WHY LEARN {courseName.toUpperCase()}?
                    </span>

                    <h2>
                        10 Reasons to Learn{" "}
                        <span>{courseName}</span>
                    </h2>

                    <p>
                        Discover why learning {courseName} can help you
                        build practical skills and create new career
                        opportunities.
                    </p>

                </div>


                {/* Reasons */}
                <Row className="course-reasons-row">

                    {reasons.map((reason, index) => (
                        <Col
                            lg="6"
                            md="6"
                            sm="12"
                            key={index}
                        >
                            <div className="course-reason-card">

                                <div className="course-reason-number">
                                    {String(index + 1).padStart(2, "0")}
                                </div>

                                <div className="course-reason-icon">
                                    <CheckCircleIcon />
                                </div>

                                <div className="course-reason-content">

                                    <h3>
                                        {reason.title}
                                    </h3>

                                    {reason.description && (
                                        <p>
                                            {reason.description}
                                        </p>
                                    )}

                                </div>

                            </div>
                        </Col>
                    ))}

                </Row>

            </Container>
        </section>
    );
}

export default CourseReasons;